import { Component, inject, OnInit } from '@angular/core';
import { Title } from '@angular/platform-browser';
import { environment } from 'src/environments/environment';

@Component({
    selector: 'app-user-management',
    standalone: false,
    templateUrl: './user-management.component.html',
    styleUrl: './user-management.component.scss',
})
export class UserManagementComponent implements OnInit {
    private title = inject(Title);

    ngOnInit() {
        this.title.setTitle('Gebruikers' + environment.titleAppend);
    }
}
